module.exports = __webpack_public_path__ + "static/media/3D.f5a646eb.svg";